// fetch EAPrograms
export const FETCH_EA_PROGRAMS_REQUEST = 'EAProgram/FETCH_EA_PROGRAMS_REQUEST';
export const FETCH_EA_PROGRAMS_SUCCESS = 'EAProgram/FETCH_EA_PROGRAMS_SUCCESS';
export const FETCH_EA_PROGRAMS_FAILURE = 'EAProgram/FETCH_EA_PROGRAMS_FAILURE';

// fetch recommended EAPrograms
export const FETCH_RECOMMENDED_EA_PROGRAMS_REQUEST =
  'EAProgram/FETCH_RECOMMENDED_EA_PROGRAMS_REQUEST';
export const FETCH_RECOMMENDED_EA_PROGRAMS_SUCCESS =
  'EAProgram/FETCH_RECOMMENDED_EA_PROGRAMS_SUCCESS';
export const FETCH_RECOMMENDED_EA_PROGRAMS_FAILURE =
  'EAProgram/FETCH_RECOMMENDED_EA_PROGRAMS_FAILURE';

export const FETCH_LAST_BOUGHT_EA_PROGRAMS_REQUEST =
  'EAProgram/FETCH_LAST_BOUGHT_EA_PROGRAMS_REQUEST';
export const FETCH_LAST_BOUGHT_EA_PROGRAMS_SUCCESS =
  'EAProgram/FETCH_LAST_BOUGHT_EA_PROGRAMS_SUCCESS';
export const FETCH_LAST_BOUGHT_EA_PROGRAMS_FAILURE =
  'EAProgram/FETCH_LAST_BOUGHT_EA_PROGRAMS_FAILURE';

// set EAProgram data
export const SET_EA_PROGRAM_DATA = 'EAProgram/SET_EA_PROGRAM_DATA';

// set recommended EAPrograms list
export const SET_RECOMMENDED_EA_PROGRAMS =
  'EAProgram/SET_RECOMMENDED_EA_PROGRAMS';
// set recently bought EAPrograms
export const SET_LAST_BOUGHT_EA_PROGRAMS =
  'EAProgram/SET_LAST_BOUGHT_EA_PROGRAMS';

// fetch EA from content
export const FETCH_EA_BY_ID_FROM_CONTENT_REQUEST =
  'EAProgram/FETCH_EA_BY_ID_FROM_CONTENT_REQUEST';
export const FETCH_EA_BY_ID_FROM_CONTENT_SUCCESS =
  'EAProgram/FETCH_EA_BY_ID_FROM_CONTENT_SUCCESS';
export const FETCH_EA_BY_ID_FROM_CONTENT_FAILURE =
  'EAProgram/FETCH_EA_BY_ID_FROM_CONTENT_FAILURE';

// fetch EA By Id
export const FETCH_EA_BY_ID_REQUEST = 'EAProgram/FETCH_EA_BY_ID_REQUEST';
export const FETCH_EA_BY_ID_SUCCESS = 'EAProgram/FETCH_EA_BY_ID_SUCCESS';
export const FETCH_EA_BY_ID_FAILURE = 'EAProgram/FETCH_EA_BY_ID_FAILURE';

// get file to blob data
export const DOWNLOAD_FILE_REQUEST = 'EAProgram/DOWNLOAD_FILE_REQUEST';
export const DOWNLOAD_FILE_SUCCESS = 'EAProgram/DOWNLOAD_FILE_SUCCESS';
export const DOWNLOAD_FILE_FAILURE = 'EAProgram/DOWNLOAD_FILE_FAILURE';
